﻿<script setup lang="ts">
import { useRegisterSW } from 'virtual:pwa-register/vue'
import AppIcon from './AppIcon.vue'

const { needRefresh, offlineReady, updateServiceWorker } = useRegisterSW({
  immediate: true
})

function close(): void {
  needRefresh.value = false
  offlineReady.value = false
}
</script>

<template>
  <Transition name="toast-list">
    <aside v-if="needRefresh || offlineReady" class="pwa-prompt" role="status">
      <AppIcon :name="needRefresh ? 'download' : 'check'" :size="21" />
      <div>
        <strong>{{ needRefresh ? 'Update available' : 'App ready offline' }}</strong>
        <p>{{ needRefresh ? 'A new version of the app is available.' : 'The app can be opened without an internet connection.' }}</p>
      </div>
      <button v-if="needRefresh" type="button" class="button button--primary button--compact" @click="updateServiceWorker(true)">Update</button>
      <button type="button" class="mini-icon-button" aria-label="Close" @click="close"><AppIcon name="close" :size="16" /></button>
    </aside>
  </Transition>
</template>
